<template>
  <main>
    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
           <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                 <h4 class="mb-0 font-size-18">File Manager</h4>
                 <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                       <li class="breadcrumb-item"><a href="javascript: void(0);">Your Server</a></li>
                       <li class="breadcrumb-item active">File Manager</li>
                    </ol>
                 </div>
              </div>
           </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="editorModal" tabindex="-1" role="dialog" aria-labelledby="editorModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editorModalLabel">Editing {{ currentName}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <prism-editor class="my-editor" v-model="code" :highlight="highlighter" line-numbers></prism-editor>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" v-on:click="saveFile()">Save changes</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Upload File Modal-->
        <div class="modal fade" id="uploadFileModal" tabindex="-1" role="dialog" aria-labelledby="uploadFileLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="uploadFileLabel">Upload Files</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <vue-dropzone id="drop1" :options="dropOptions" v-on:vdropzone-sending="sendingEvent" v-on:vdropzone-success="uploadComplete"></vue-dropzone>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Create File Modal-->
        <div class="modal fade" id="createFileModal" tabindex="-1" role="dialog" aria-labelledby="createFileLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="createFileLabel">Create a new file</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <label for="folder-name">Enter a file name</label>
                <input id="folder-name" type="text" class="form-control" placeholder="File Name" v-model="currentName">
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" v-on:click="createFile()" data-dismiss="modal">Create</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Create Folder Modal-->
        <div class="modal fade" id="createFolderModal" tabindex="-1" role="dialog" aria-labelledby="createFolderLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="createFolderLabel">Create a folder</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <label for="folder-name">Enter a folder name</label>
                <input id="folder-name" type="text" class="form-control" placeholder="Folder Name" v-model="folderName">
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" v-on:click="createFolder()">Create</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Rename Modal -->
        <div class="modal fade" id="renameModal" tabindex="-1" role="dialog" aria-labelledby="renameLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="renameLabel">Rename File/Folder</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <label for="folder-name">Enter a name</label>
                <input id="folder-name" type="text" class="form-control" placeholder="File/Folder Name" v-model="renameName">
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" v-on:click="rename()">Rename</button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="deleteLabel">WARNING!</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="modal-body">
                   <h5>Delete {{currentName}}?</h5>
                   <p>By performing this action, you will permantly loose {{currentName}}. Do you wish to continue?</p>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" v-on:click="deleteFile()">Delete {{currentName}}</button>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <div class="row mb-2">
                     <div class="col-sm-4">
                        <div class="search-box mr-2 mb-2 d-inline-block">
                           <div class="position-relative">
                              <input type="text" class="form-control" placeholder="Search...">
                              <i class="bx bx-search-alt search-icon"></i>
                           </div>
                        </div>
                     </div>
                     <div class="col-sm-8">
                        <div class="text-sm-right">
                           <button type="button" class="btn btn-light btn-rounded waves-effect waves-light mb-2 mr-2" data-toggle="modal" data-target="#uploadFileModal"><i class="bx bx-upload mr-1"></i> File Upload</button>
                           <button type="button" class="btn btn-light btn-rounded waves-effect waves-light mb-2 mr-2" data-toggle="modal" data-target="#createFileModal" v-on:click="prepareCreateFileModal()"><i class="bx bx-file mr-1"></i> New File</button>
                           <button type="button" class="btn btn-light btn-rounded waves-effect waves-light mb-2 mr-2" data-toggle="modal" data-target="#createFolderModal"><i class="bx bx-folder-open mr-1"></i> New Folder</button>
                           <button type="button" class="btn btn-light btn-rounded waves-effect waves-light mb-2 mr-2"><i class="bx bxs-down-arrow mr-1"></i> Mass Actions</button>
                        </div>
                     </div>
                     <!-- end col-->
                  </div>
                  <div class="table-responsive">
                     <table class="table table-centered table-nowrap">
                        <thead class="thead-light">
                           <tr>
                              <th style="width: 20px;">
                                 <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                                    <label class="custom-control-label" for="customCheck1">&nbsp;</label>
                                 </div>
                              </th>
                              <th>File Name</th>
                              <th>Size</th>
                              <th>Date Last Modified</th>
                              <th>Action</th>
                           </tr>
                        </thead>
                        <tbody>
                          <tr v-if="path.length != 0">
                            <td>
                               <div class="custom-control custom-checkbox">
                                  <input type="checkbox" class="custom-control-input" id="customCheck11">
                                  <label class="custom-control-label" for="customCheck11">&nbsp;</label>
                               </div>
                            </td>
                            <td><a class="link" v-on:click="goHome()">.</a></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr v-if="path.length != 0">
                            <td>
                               <div class="custom-control custom-checkbox">
                                  <input type="checkbox" class="custom-control-input" id="customCheck11">
                                  <label class="custom-control-label" for="customCheck11">&nbsp;</label>
                               </div>
                            </td>
                            <td><a class="link" v-on:click="goUp()">..</a></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                           <tr v-bind:key="file.name" v-for="file in files">
                              <td>
                                 <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck11">
                                    <label class="custom-control-label" for="customCheck11">&nbsp;</label>
                                 </div>
                              </td>
                              <td v-if="file.directory"><a class="link" v-on:click="pushName(file.name)">{{ file.name }}</a></td>
                              <td v-else>{{ file.name }}</td>
                              <td>{{ file.size | prettyBytes}}</td>
                              <td>{{ file.last_modified | relativeDate }}</td>
                              <td>
                                 <div class="dropdown">
                                    <a href="#" class="dropdown-toggle card-drop" data-toggle="dropdown" aria-expanded="false">
                                    <i class="mdi mdi-dots-horizontal font-size-18"></i>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-down">
                                       <a class="dropdown-item" v-if="!file.directory" v-on:click="editFile(file.name)">Edit File</a>
                                       <a class="dropdown-item" v-on:click="prepareRenameModal(file.name, file.directory)" data-toggle="modal" data-target="#renameModal">Rename {{ file.directory ? 'Folder' : 'File'}}</a>
                                       <a class="dropdown-item" v-if="!file.directory" v-on:click="fetchFile(file.name, false)">Download File</a>
                                       <a class="dropdown-item" data-toggle="modal" data-target="#deleteModal" v-on:click="prepareDeleteModal(file.name)">Delete {{ file.directory ? 'Folder' : 'File'}}</a>
                                    </div>
                                 </div>
                              </td>

                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </div>
      </div>
    </div>
  </main>
</template>

<script>
import store from '../../store'

import downloadjs from 'downloadjs'
import vueDropzone from 'vue2-dropzone'

// import Prism Editor
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css' // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-properties'
import 'prismjs/themes/prism-tomorrow.css' // import syntax highlighting styles

import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'FileManager',
  components: {
    PrismEditor,
    vueDropzone
  },
  data () {
    return {
      code: 'console.log("Hello World")',
      files: [],
      path: [],
      folderName: '',
      renameName: '',
      currentName: '',
      currentDirectory: false,
      fileType: '',
      dropOptions: {
        url: store.state.launchpadUrl + '/files/upload',
        dictDefaultMessage: '<div class="dz-message needsclick"><div class="mb-3"><i class="display-4 text-muted bx bxs-cloud-upload"></i></div><h4>Drop files here or click to upload.</h4></div>',
      }
     }
  },
  mounted () {
    this.fetchData()
  },
  filters: {
    prettyBytes (num) {
      // jacked from: https://github.com/sindresorhus/pretty-bytes
      if (typeof num !== 'number' || isNaN(num)) {
        throw new TypeError('Expected a number');
      }

      var exponent;
      var unit;
      var neg = num < 0;
      var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      if (neg) {
        num = -num;
      }

      if (num < 1) {
        return (neg ? '-' : '') + num + ' B';
      }

      exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
      num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
      unit = units[exponent];

      return (neg ? '-' : '') + num + unit;
    }
  },
  methods: {
    sendingEvent (file, xhr, formData) {
      console.log('sending...')
      formData.append('currentFolder', this.getPath())
    },
    uploadComplete (file, response)
    {
      if(response === 'OK') this.fetchData()
    },
    highlighter (code) {
      return code
      //return highlight(code, languages.properties) // languages.<insert language> to return html with markup
    },
    goHome () {
      this.path = []
      console.log(this.path)
      this.fetchData()
    },
    goUp () {
      this.path.splice(-1,1)
      console.log(this.path)
      this.fetchData()
    },
    pushName (name) {
      this.path.push(name)
      this.fetchData()
    },
    getPath () {
      return '/'.concat(this.path.join('/'))
    },
    createFolder () {
      jQuery('#createFolderModal').modal('hide')
      let data = new URLSearchParams()

      var folderPath = this.path
      folderPath.push(this.folderName)
      data.set('path', '/'.concat(folderPath.join('/')))

      fetch(store.state.launchpadUrl + '/files/folder/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      }).then(response => {
        this.folderName = ''
        this.fetchData()
        console.log(this.path)
      }).catch(err => console.log(err))
    },
    prepareRenameModal (name, directory) {
      jQuery('#renameModal .modal-title')[0].innerText = directory ? 'Rename Folder' : 'Rename File'
      this.renameName = name
      this.currentName = name
      this.currentDirectory = directory
    },
    prepareCreateFileModal () {
      this.currentName = ''
      this.code = ''
    },
    rename (name, directory) {
      let data = new URLSearchParams()
      data.set('path', this.getPath())
      data.set('fromName', this.currentName)
      data.set('toName', this.renameName)
      data.set('directory', this.currentDirectory)

      fetch(store.state.launchpadUrl + '/files/rename', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      }).then(response => {
        if(response.status == 200)
        {
          jQuery('#renameModal').modal('hide')
          this.fetchData()
        }
      })
    },
    fetchData () {

      let data = new URLSearchParams()
      data.set('path', this.getPath())

      fetch(store.state.launchpadUrl + '/files/list', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      }).then(response => {
        return response.json()
      }).then(data => {
        var sortedData = data.sort((a, b) => {
          if (a.directory !== b.directory) {
            return a.directory ? -1 : 1;
          } else {
            return a.name > b.name ? 1 : -1;
          }
        })
        this.files = sortedData
      })
    },
    createFile () {
      jQuery('#editorModal').modal('show')
    },
    editFile (name) {
      this.currentName = name
      this.fetchFile(name, true)
      jQuery('#editorModal').modal('show')
    },
    fetchFile (name, edit) {
      console.log('fetchFile called')
      let data = new URLSearchParams()
      data.set('path', this.getPath())
      data.set('name', name)


      fetch(store.state.launchpadUrl + '/files/download', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      }).then(response => {

        if(response.status != 200) return

        if(edit)
        {
          response.text().then(contents => {
            let type = response.headers.get('Content-Type').split(";")[0]
            this.fileType = type
            this.code = contents
          })
          return
        }

        response.blob().then(contents => {
          let type = response.headers.get('Content-Type').split(";")[0]
          downloadjs(contents, name, type)

        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },
    saveFile () {

      let data = new URLSearchParams()
      data.set('path', this.getPath())
      data.set('name', this.currentName)
      data.set('contents', this.code)

      fetch(store.state.launchpadUrl + "/files/save", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      }).then(response => {
        console.log(response)
        if(response.status == 200) {
          jQuery('#editorModal').modal('hide')
          this.fetchData()
        }
      })
    },
    prepareDeleteModal(name)
    {
      this.currentName = name
    },
    deleteFile () {
      let data = new URLSearchParams()
      data.set('path', this.getPath())
      data.set('name', this.currentName)

      fetch(store.state.launchpadUrl + "/files/delete", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      }).then(response => {
        console.log(response)
        if(response.status == 200) {
          jQuery('#deleteModal').modal('hide')
          this.fetchData()
        }
      })
    }
  }
}
</script>

<style scoped>
.link {
  color: #556ee6;
  font-weight: bold;
  cursor: pointer;
}
.dropzone {
	min-height: 230px;
	border: 2px dashed #ced4da;
	border-radius: 6px
}

.dropzone:hover
{
  background:rgba(255,255,255,0.05);
}

.dropzone .dz-message {
	font-size: 24px;
	width: 100%
}

.dropzone .dz-message {
	font-size: 24px;
	width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/panel/FileManager.vue